export interface NavItem {
  label: string;
  path: string;
}

// Add a new tab here to extend the nav — no other changes required.
export const NAV_ITEMS: NavItem[] = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
];
